import "./index.scss"
import React from "react"
import { ContentProps } from "../interfaces"
import { formatNumber, toPercentage } from "../../../../../helpers/numbers"
import { useIntl } from "react-intl"

const enum className {
	main = "main-metric",
	second = "second-metric",
	positive = "font-green",
	negative = "font-red",
}

const enum decimalsMetric {
	numeric = 2,
	percentage = 1,
}

const Content = (props: ContentProps) => {
	const { metric, percentage, withColor = false } = props
	const intl = useIntl()

	const contentColor = () => {
		return withColor ? selectColor() : ""
	}

	const selectColor = () => {
		return percentage && percentage > 0
			? className.positive
			: className.negative
	}

	const renderSummary = () => {
		if (metric && percentage) {
			return renderMetric(
				getMetricPercentage(percentage),
				`(${formatNumber(metric, intl, decimalsMetric.numeric)})`
			)
		}
		return renderSingleMetric()
	}

	const renderMetric = (mainMetric: string, secondMetric?: string) => {
		return (
			<>
				<span className={className.main}>{mainMetric}</span>
				<span className={className.second}>{secondMetric}</span>
			</>
		)
	}

	const renderSingleMetric = () => {
		if (metric !== null) {
			const metricNumber = formatNumber(
				metric as number,
				intl,
				decimalsMetric.numeric,
				true
			).split(" ")
			return renderMetric(metricNumber[0], metricNumber[1])
		}
		if (percentage !== null) {
			return renderMetric(getMetricPercentage(percentage as number))
		}
		return ""
	}

	const getMetricPercentage = (metricPercentage: number) => {
		return toPercentage({
			value: metricPercentage,
			intl,
			decimals: decimalsMetric.percentage,
			withPercentageChar: true,
			withPositiveSymbol: true,
		})
	}

	return (
		<div className="card-content" data-testid="card-content">
			<p className={contentColor()}>{renderSummary()}</p>
		</div>
	)
}

export default Content
